/* eslint-disable jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events, react/prop-types */
import clsx from "clsx";
import { get, isNil } from "lodash";
import React, { useEffect, useState } from "react";
import PerfectScrollbar from "react-perfect-scrollbar";
import Select, { components, createFilter } from "react-select";
import { Checkbox } from "../Checkbox";
import "./MultiSelectSearch.scss";
import multiSelectSearchStyles from "./MultiSelectSearchStyles";

const PERFECT_SCROLLBAR_OPTIONS = {
  wheelSpeed: 1,
  swipeEasing: true,
  wheelPropagation: false,
  minScrollbarLength: 60,
  scrollingThreshold: 1000,
};

function MenuList(props) {
  const { children, ...rest } = props;

  return (
    <components.MenuList {...rest}>
      <PerfectScrollbar
        className="scroll"
        data-height="240"
        data-mobile-height="240"
        data-scroll="true"
        options={PERFECT_SCROLLBAR_OPTIONS}
        style={{ maxHeight: 235, padding: "5px 0" }}
      >
        {children}
      </PerfectScrollbar>
    </components.MenuList>
  );
}

function Option(props) {
  const { isSelected, children, data } = props;

  return (
    <components.Option {...props}>
      <div className="Uic-MultiSelectSearch-option">
        <Checkbox
          className="Uic-MultiSelectSearch-centerCB"
          readOnly
          checked={isSelected}
          label={children}
        />
        {!isNil(data.count) ? (
          <div className="Uic-MultiSelectSearch-count">{data.count}</div>
        ) : null}
      </div>
    </components.Option>
  );
}

function ValueContainer(props) {
  const { children, clearValue, options, selectProps, setValue } = props;

  const length = get(selectProps, "value.length");
  const placeholder = get(selectProps, "placeholder");
  const firstLabel = get(selectProps, "value[0].label");
  const inputValue = get(selectProps, "inputValue");
  const clearValueRestoresAll = get(selectProps, "clearValueRestoresAll");

  const [, input] = children;

  let value = null;
  if (length === 1) {
    value = firstLabel;
  } else if (length > 1) {
    value = length;
  }

  return (
    <div className="Uic-MultiSelectSearch-valueContainer">
      {value && (
        <div
          className={clsx(
            "Uic-MultiSelectSearch-pill",
            inputValue && "invisible"
          )}
        >
          <span className="Uic-MultiSelectSearch-value">{value}</span>
          <span
            className={clsx("fas fa-xmark p-2", "Uic-MultiSelectSearch-clear")}
            onClick={() =>
              clearValueRestoresAll ? setValue(options) : clearValue()
            }
          />
        </div>
      )}
      <span
        className={clsx(
          "Uic-MultiSelectSearch-label",
          inputValue && "invisible"
        )}
      >
        {placeholder}
      </span>
      {input}
    </div>
  );
}

const getSelectedOptions = (options, value) => {
  let allOptions = options;

  // is grouped
  if (options?.[0]?.options) {
    allOptions = options.reduce((acc, item) => acc.concat(item.options), []);
  }

  return allOptions?.filter((option) => value.includes(option.value)) ?? [];
};

function MultiSelectSearch(props) {
  const {
    id,
    name,
    placeholder,
    options,
    remoteValue,
    onChange,
    getFilter = () => {},
    clearValueRestoresAll = false,
    ...rest
  } = props;
  const [value, setValue] = useState([]);

  useEffect(() => {
    if (remoteValue !== undefined) {
      setValue(remoteValue ?? []);
    }
  }, [remoteValue]);

  const internalOnChange = (val) => {
    setValue(val);
    onChange(val);
  };

  useEffect(() => {
    if (getFilter) {
      getFilter(internalOnChange);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div
      onClick={(event) => event.stopPropagation()}
      className="Uic-MultiSelectSearch-wrapper"
    >
      <Select
        id={id}
        name={name}
        placeholder={placeholder}
        options={options}
        isMulti
        autoBlur
        isSearchable
        closeMenuOnSelect={false}
        hideSelectedOptions={false}
        isClearable={false}
        value={getSelectedOptions(options, value)}
        onChange={(selectedOptions) => {
          const newValue = selectedOptions?.map((option) => option.value) ?? [];
          internalOnChange(newValue);
        }}
        styles={multiSelectSearchStyles}
        classNamePrefix="Uic-MultiSelectSearch"
        components={{ MenuList, Option, ValueContainer }}
        filterOption={createFilter({
          matchFrom: "any",
          stringify: (option) => `${option.label}`,
        })}
        clearValueRestoresAll={clearValueRestoresAll}
        {...rest}
      />
    </div>
  );
}

export default MultiSelectSearch;
